import React from "react";

export default function EmptyBasket() {

    return <div className="empty-basket">
        <div className="empty-basket-title">Ваша корзина пуста</div>
        <a className="empty-basket-link" href="/catalog/">Перейти к покупкам</a>
    </div>;

}